import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EmptyTable = ({
  navMarkerName,
  onResetClick
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [navMarkerName && /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsxs(View, {
      marginBlock: "1000",
      role: "alert",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Pictogram, {
        inlineSize: "100%",
        marginBlockEnd: "600",
        name: "EmptyStateSearch"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.common.emptyTable.title"
        })
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.common.emptyTable.description"
        }), /*#__PURE__*/_jsx("br", {}), onResetClick && /*#__PURE__*/_jsx(Button, {
          marginBlockStart: "200",
          onClick: onResetClick,
          use: "transparent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.common.emptyTable.resetFilters"
          })
        })]
      })]
    })]
  });
};
export default EmptyTable;